import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useContext, useEffect, useState } from "react";
import { getUnseenAlertsCount } from "../apis";
var DruvaAlertsContext = /*#__PURE__*/createContext();

var DruvaAlertsProvider = function DruvaAlertsProvider(_ref) {
  var children = _ref.children,
      _ref$apiConfig = _ref.apiConfig,
      apiConfig = _ref$apiConfig === void 0 ? {} : _ref$apiConfig,
      getAccessTokenCall = _ref.getAccessTokenCall,
      _ref$allowedAdminRole = _ref.allowedAdminRoles,
      allowedAdminRoles = _ref$allowedAdminRole === void 0 ? ["Druva Cloud"] : _ref$allowedAdminRole,
      _ref$uiConfig = _ref.uiConfig,
      uiConfig = _ref$uiConfig === void 0 ? {
    labelForAdminRole: "All Druva Cloud Administrator"
  } : _ref$uiConfig,
      _ref$isMsp = _ref.isMsp,
      isMsp = _ref$isMsp === void 0 ? false : _ref$isMsp;

  /**alertsApiPath is in the form of '/realize/eventmanagement/v1'
   * The other paths will be appended to it.
   */
  var alertsApiPath = apiConfig.alertsApiPath,
      accessTokenApiPath = apiConfig.accessTokenApiPath,
      alertsApiBaseUrl = apiConfig.alertsApiBaseUrl;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      unseenAlertsCount = _useState2[0],
      setUnseenAlertsCount = _useState2[1];

  var updateUnseenAlertsCount = function updateUnseenAlertsCount() {
    getUnseenAlertsCount({
      apiBaseUrl: alertsApiBaseUrl,
      pathprefix: alertsApiPath,
      accessTokenApiPath: getAccessTokenCall && typeof getAccessTokenCall === "function" ? getAccessTokenCall : accessTokenApiPath,
      getAccessTokenCall: getAccessTokenCall
    }).then(function (response) {
      var count = response.count;
      setUnseenAlertsCount(count);
    })["catch"](function (e) {
      console.log("Error in fetching unseen alerts count", e);
    });
  };

  useEffect(function () {
    updateUnseenAlertsCount();
  }, []);
  var value = {
    unseenAlertsCount: unseenAlertsCount,
    allowedAdminRoles: allowedAdminRoles,
    uiConfig: uiConfig,
    apiConfig: _objectSpread(_objectSpread({}, apiConfig), {}, {
      accessTokenApiPath: getAccessTokenCall && typeof getAccessTokenCall === "function" ? getAccessTokenCall : accessTokenApiPath
    }),
    isMsp: isMsp,
    updateUnseenAlertsCount: updateUnseenAlertsCount
  };
  return /*#__PURE__*/React.createElement(DruvaAlertsContext.Provider, {
    value: value
  }, children);
};

var useDruvaAlerts = function useDruvaAlerts() {
  var alertscontext = useContext(DruvaAlertsContext);

  if (!alertscontext) {
    throw "Could not find DruvaAlertsContext provider wrapped around the component";
  }

  return alertscontext;
};

export { DruvaAlertsContext, DruvaAlertsProvider, useDruvaAlerts };